import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { AGENDA_PERMISSION_CODES } from 'permissions/constants/agendaPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { AGENDA_PERMISSION_CODES };

const usePermissionsAgenda = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.AGENDA),
      canViewSection: hasPermission(AGENDA_PERMISSION_CODES.VIEW_SECTION),
      canDownloadExcel: hasPermission(AGENDA_PERMISSION_CODES.DOWNLOAD_EXCEL),
      canCreateAppointment: hasPermission(AGENDA_PERMISSION_CODES.CREATE_APPOINTMENT),
      canManageAppointment: hasPermission(AGENDA_PERMISSION_CODES.MANAGE_APPOINTMENT),
      canConnectOutlook: hasPermission(AGENDA_PERMISSION_CODES.OUTLOOK_CONNECTION),
      canViewOthersCalendar: hasPermission(AGENDA_PERMISSION_CODES.VIEW_OTHERS_CALENDAR),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsAgenda;
